import React from "react";
import styles from "./UserAvatar.module.css";
import { API_BASE_URL } from "../../../utils/constants";
import BaseAvatar from "../../../images/user_avatar.png";

const statusVariant = (status) => {
  switch (status) {
    case "blocked":
      return "danger";
    case "deleted":
      return "secondary";
    default:
      return "success";
  }
};

const UserAvatar = ({ image }) => {
  console.log("image :>> ", image);
  return (
    <>
      {image ? (
        <img
          src={API_BASE_URL + "/" + image}
          alt="FOTO"
          className={styles.avatar}
        />
      ) : (
        <img src={BaseAvatar} alt="FOTO" className={styles.avatar} />
      )}
    </>
  );
};

export default UserAvatar;
